import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import React, { useEffect, useRef } from "react";
import { PropsWithChildren } from "react";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-printable";

interface PrintableProps extends PropsWithChildren {
    header?: JSX.Element;
    footer?: JSX.Element;
    cssClassName?: string;
}

const Printable = ({
    children,
    header,
    footer,
    cssClassName = "",
}: PrintableProps) => {
    const headerRef = useRef<HTMLElement>(null);
    const footerRef = useRef<HTMLElement>(null);

    // Seems dirty but has to happen
    useEffect(() => {
        document.body.style.height = "100%";
    }, []);

    const handlePrintClick = () => {
        window.scrollTo({ top: 0, behavior: "instant" });
        setTimeout(() => {
            window.print();
        }, 100);
    };

    return (
        <>
            <div className={`${CSS_CLASS_NAME} ${cssClassName}`}>
                <Button
                    style={ButtonStyles.Secondary}
                    cssClassName={`${CSS_CLASS_NAME}__printButton`}
                    onClick={handlePrintClick}>
                    {t("print")}
                </Button>
                <table className={`${CSS_CLASS_NAME}__table`}>
                    <thead>
                        <tr>
                            <td>
                                <div
                                    className={`${CSS_CLASS_NAME}__headerSpace`}
                                />
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <main className={`${CSS_CLASS_NAME}__content`}>
                                    {children}
                                </main>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>
                                <div
                                    className={`${CSS_CLASS_NAME}__footerSpace`}>
                                    {footer && (
                                        <footer
                                            ref={footerRef}
                                            className={`${CSS_CLASS_NAME}__footer`}>
                                            {footer}
                                        </footer>
                                    )}
                                </div>
                            </th>
                        </tr>
                    </tfoot>
                </table>
                {header && (
                    <header
                        ref={headerRef}
                        className={`${CSS_CLASS_NAME}__header`}>
                        {header}
                    </header>
                )}
            </div>
        </>
    );
};

export default Printable;
